import { IUser } from '.';

export enum FileOrigin {
  NAMES = 'Names',
  VEHICLES = 'Vehicles',
  ARRESTEES = 'Arrests',
  PROPERTIES = 'Properties',
  EMAIL = 'Email',
  PRINT = 'Print',
}

export enum PrintOrigin {
  COMPLAINT_POLICY = 'complaint_policy',
  DIR = 'DIR',
  WITNESS_DEPOSITION = 'witness_deposition',
}

export interface IFileMeta {
  printOrigin?: PrintOrigin | string;
  content?: any;
}

export interface IFile {
  _id?: string;
  file?: File;
  name: string;
  size: number;
  mimeType: string;
  description?: string;
  url?: string;
  uploadedBy?: IUser | string;
  origin?: string;
  entity?: string;
  meta?: IFileMeta;
  error?: string;
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
}
